import { createStyles, Theme } from "@material-ui/core";

export const styles = ({spacing}: Theme) => createStyles({
    history: {
        flexBasis: "100%",
        marginTop: spacing.unit,
        "& td": {
            padding: `${spacing.unit}px ${spacing.unit * 2}px`
        }
    },
    buttonLabel: {
        marginRight: spacing.unit,
        marginLeft: spacing.unit,
        textTransform: "initial"
    },
    panelActions: {
        flexBasis: "100%",
        justifyContent: "flex-end",
        marginTop: spacing.unit * 2
    },
    panelDetails: {
        padding: spacing.unit * 2,
        paddingBottom: spacing.unit * 3
    },
    step: {
        display: "flex",
        marginTop: spacing.unit,
        fontWeight: 100,
        "&:first-child": {
            fontWeight: 500
        },
        "& span": {
            fontWeight: 500
        }
    },    
    summary: {
        padding: spacing.unit * 2
    },
    summaryDate: {
        flexBasis: "10%"        
    },
    summaryLabel: {
        flexBasis: "28%"        
    },
    summaryName: {
        flexBasis: "22%"        
    },
    summaryHistory: {

    },
    /*
    table: {
        tableLayout: "fixed"
    },
    */
    cell: {
        border: 0,
        padding: 0,
        whiteSpace: "nowrap",
        "&:last-child": {
            paddingRight: 0
        }
    },
    action: {
        /*
        backgroundColor: "white",
        boxShadow: "0 1px 2px 0 rgba(0,0,0,0.1)",
        border: 0
        */
    }
});


// WEBPACK FOOTER //
// ./src/components/QuotationsList/QuotationsList.style.tsx